import { render, staticRenderFns } from "./CompConsentForm.vue?vue&type=template&id=16b90184&scoped=true&"
import script from "./CompConsentForm.vue?vue&type=script&lang=js&"
export * from "./CompConsentForm.vue?vue&type=script&lang=js&"
import style0 from "./CompConsentForm.vue?vue&type=style&index=0&id=16b90184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b90184",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VCard,VDialog,VImg,VRadio,VRadioGroup})
